<template>
  <div id="local" :class="getLocalSideClasses">
    <div
      v-show="localParticipantScreenData"
      id="localScreenshare"
      :class="getLocalScreenshareClasses"
    ></div>
    <div id="local-video" :class="getLocalVideoClasses">
      <LocalVideoTurnedOff
        v-show="!localVideoTrack"
        :localVideoConfig="localVideoConfig"
      />
      <div class="videoControls" v-show="localVideoTrack">
        <div class="toggleMirror" @click="toggleMirror">
          <IconBase
            icon-name="Reverse"
            class="toggleMirrorIcon"
            iconColor="#000"
            viewBox="0 0 512 512"
            width="30"
            height="30"
            ><IconFlip
          /></IconBase>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import LocalVideoTurnedOff from "./LocalVideoTurnedOff";
import IconBase from "../../../../components/IconBase";
import IconFlip from "../../../../components/SVG/IconFlip";

import { getLayoutElementClasses } from "../SessionHelpers/layout";

export default {
  name: "LocalParticipant",
  components: {
    LocalVideoTurnedOff,
    IconBase,
    IconFlip,
  },
  computed: {
    ...mapState({
      localParticipantData: (state) => state.room.localParticipantData,
      localParticipantScreenData: (state) =>
        state.room.localParticipantScreenData,
      localVideoTrack: (state) => state.room.localVideoTrack,
      localVideoConfig: (state) =>
        state.preferences.layoutConfig.localVideoConfig,
      leftSideConfig: (state) => state.preferences.layoutConfig.leftSideConfig,
      videoIsMirrored: (state) => state.preferences.videoIsMirrored,
    }),
    getLocalSideClasses() {
      const config = this.leftSideConfig;
      return getLayoutElementClasses(config, "localSide");
    },
    getLocalVideoClasses() {
      const config = this.localVideoConfig;
      return getLayoutElementClasses(config, "localVideo");
    },
    getLocalScreenshareClasses() {
      const config = this.leftSideConfig;
      return getLayoutElementClasses(config, "localScreenshare");
    },
  },
  methods: {
    toggleMirror() {
      this.$store.dispatch("preferences/toggleMirror");
    },
  },
};
</script>